import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFab from "./WhatsAppFab";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1 pt-[132px] md:pt-[148px] lg:pt-[164px]" data-testid="site-main">
        {children}
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
